"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _polished = require("../../helpers/polished");
var _styled = require("../../styled");
var _fonts = require("../fonts");
var _baseTheme = require("./baseTheme");
var _templateObject;
var rem = function rem(size) {
  return (0, _polished.rem)(size, _baseTheme.basePixelSize);
};
var gutterWidth = rem(15);
var GlobalStyles = (0, _styled.createGlobalStyle)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n  :root {\n    font: 400 ", "px/1.43 \"Montserrat\", sans-serif;\n  }\n  body {\n    padding: 0;\n    margin: 0;\n    font-family: \"Montserrat\", sans-serif;\n  }\n"])), _fonts.invitaFonts, _baseTheme.basePixelSize);
var colors = {
  red: '#a72024',
  black: '#000',
  darkGrey: '#424242',
  grey: '#E1DEDD',
  white: '#FFF'
};
var contextualColors = {
  primary: colors.darkGrey,
  secondary: colors.darkGrey,
  link: colors.red,
  backgroundPrimary: colors.white,
  backgroundSecondary: colors.grey,
  lightboxBackground: colors.white,
  overlayText: colors.darkGrey,
  overlayButton: colors.red
};
var baseTypography = {
  fontFamily: '"Lausanne", sans-serif',
  titleFontFamily: '"Reckless", sans-serif',
  inputFontFamily: '"Lausanne", sans-serif'
};
var typography = {
  imagePageTitle: {
    fontFamily: baseTypography.fontFamily,
    fontWeight: 700,
    fontSize: (0, _styled.ifProp)('small', rem(16), rem(22)),
    lineHeight: (0, _styled.ifProp)('small', 1.18, 1.18),
    fontSizeDesktop: (0, _styled.ifProp)('small', rem(50), rem(63)),
    lineHeightDesktop: (0, _styled.ifProp)('small', 1, 1.12),
    marginTop: 0,
    marginBottom: rem(30),
    textTransform: 'uppercase',
    textShadow: '0 0 30px rgba(0, 0, 0, 0.43)',
    letterSpacing: rem(2)
  },
  pageTitle: {
    fontFamily: baseTypography.titleFontFamily,
    fontWeight: 200,
    fontSize: (0, _styled.ifProp)('small', rem(42), rem(36)),
    fontStyle: 'normal',
    lineHeight: (0, _styled.ifProp)('small', rem(50), rem(44)),
    marginTop: 0,
    marginBottom: rem(30),
    textTransform: 'none',
    letterSpacing: 0,
    color: colors.darkGrey
  },
  headline: {
    fontFamily: baseTypography.titleFontFamily,
    fontWeight: 400,
    fontSize: rem(24),
    fontStyle: 'normal',
    lineHeight: 1.375,
    fontSizeDesktop: rem(30),
    lineHeightDesktop: 1.375,
    marginTop: rem(10),
    marginBottom: rem(10),
    textTransform: 'normal',
    letterSpacing: 0,
    color: colors.darkGrey
  },
  subHeadline: {
    fontFamily: baseTypography.fontFamily,
    fontWeight: 400,
    fontSize: rem(20),
    fontStyle: 'normal',
    lineHeight: 1.375,
    fontSizeDesktop: rem(20),
    lineHeightDesktop: 1.375,
    marginTop: rem(10),
    marginBottom: rem(10),
    textTransform: 'normal',
    letterSpacing: 0,
    color: colors.darkGrey
  },
  title: {
    fontFamily: baseTypography.titleFontFamily,
    fontWeight: 400,
    fontSize: rem(16),
    lineHeight: 1.428,
    fontSizeDesktop: rem(16),
    lineHeightDesktop: 1.428,
    marginTop: 0,
    marginBottom: rem(30),
    textTransform: 'none',
    letterSpacing: 0
  },
  preamble: {
    fontFamily: baseTypography.fontFamily,
    fontWeight: 400,
    fontSize: rem(15),
    lineHeight: rem(22),
    fontSizeDesktop: rem(18),
    lineHeightDesktop: 1.44,
    marginTop: 0,
    marginBottom: rem(30),
    textTransform: 'none',
    letterSpacing: 0,
    color: colors.darkGrey
  },
  paragraph: {
    fontFamily: baseTypography.fontFamily,
    fontWeight: 400,
    fontSize: (0, _styled.switchProp)('size', {
      small: rem(14),
      large: rem(18),
      default: rem(16)
    }),
    lineHeight: (0, _styled.switchProp)('size', {
      small: 1.5,
      large: 1.375,
      default: 1.428
    }),
    fontSizeDesktop: (0, _styled.switchProp)('size', {
      small: rem(14),
      large: rem(18),
      default: rem(16)
    }),
    lineHeightDesktop: (0, _styled.switchProp)('size', {
      small: 1.5,
      large: 1.375,
      default: 1.428
    }),
    marginTop: 0,
    marginBottom: rem(30),
    textTransform: 'none',
    letterSpacing: 0,
    color: colors.darkGrey
  },
  link: {
    color: contextualColors.link,
    textDecoration: 'underline'
  }
};
var tooltip = {
  colors: {
    primaryColor: colors.white,
    primaryBackground: colors.darkGrey
  }
};
var forms = {
  colors: {
    selected: colors.red
  }
};
var button = {
  borderRadius: 0,
  borderWidth: '0 0 1px 0',
  borderLeftPosition: '15%',
  borderRightPosition: '15%',
  fontFamily: baseTypography.fontFamily,
  fontSize: rem(13),
  fontWeight: '400',
  textTransform: 'uppercase',
  letterSpacing: rem(1.5),
  colors: {
    primaryColor: colors.white,
    primaryBackground: colors.red,
    secondaryColor: colors.white,
    secondaryBackground: colors.darkGrey,
    successColor: colors.white,
    successBackground: colors.red
  },
  margin: '0',
  padding: (0, _styled.switchProp)('size', {
    small: (0, _styled.ifProp)({
      kind: 'inverted'
    }, rem(10) + " " + rem(0), rem(10) + " " + rem(40)),
    normal: (0, _styled.ifProp)({
      kind: 'inverted'
    }, rem(10) + " " + rem(0), rem(15) + " " + rem(45)),
    large: (0, _styled.ifProp)({
      kind: 'inverted'
    }, rem(10) + " " + rem(0), rem(20) + " " + rem(50))
  }),
  siblingMargin: gutterWidth
};
var theme = {
  basePixelSize: _baseTheme.basePixelSize,
  GlobalStyles: GlobalStyles,
  typography: typography,
  tooltip: tooltip,
  button: button,
  forms: forms,
  colors: Object.assign({}, colors, contextualColors)
};
var _default = exports.default = theme;